import React, {Component} from 'react';
import {Col, ControlLabel, Form, FormGroup, FormControl} from "react-bootstrap";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import moment from 'moment'
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

export default class SprzedazSearchbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            trasa: null,
            godzinaOdjazdu: null,
            status: null,
            statusy: [
                {value: -1, label: ' do opłaty'},
                {value: 1, label: 'opłacony'},
                {value: 0, label: 'rezerwacja'},
                {value: 2, label: 'skasowany'},
                {value: -2, label: 'anulowano przez klienta'},
                {value: -3, label: 'anulowano przez operatora'},
                {value: -4, label: 'zwrócony'},
                {value: -5, label: 'nieopłacony'},
            ],
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeGodzinaOdjazdu = this.onChangeGodzinaOdjazdu.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                          wartosc={option.status}
                                                                                                                          czyMarginesLewy={true}/>
        </div>
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    onChangeGodzinaOdjazdu(e) {
        this.setState({godzinaOdjazdu: e.target.value})
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    onClickSzukaj() {
        this.setState({czyByloSzukanie: false})
        if (DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd) > DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)) {
            alert('Data do nie może być wcześniejsza od daty od')
        } else {

            let data = {
                "dataDo": DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                "dataOd": DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                "godz1p": Boolean(this.state.godzinaOdjazdu) ? this.state.godzinaOdjazdu.replace(':', '.') : null,
                "idTr": (Boolean(this.state.trasa)) ? this.state.trasa.idTr : null,
                "nazTr": (Boolean(this.state.trasa)) ? this.state.trasa.nazTr : null,
                "statPoz": (Boolean(this.state.status)) ? this.state.status.value : null,
                "statusNazwa": (Boolean(this.state.status)) ? this.state.status.label : null
            }
            this.props.handleClickSzukaj(data)
        }
    }


    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={2}>
                            <ControlLabel>Data od <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Data do <span className={'req'}>*</span></ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                        </Col>
                        <Col xs={3}>
                            <ControlLabel>Trasa</ControlLabel>
                            <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa} options={this.props.trasy} labelKey={'nazTr'}
                                       valueKey={'idTr'} valueRenderer={this.formatTrasaSelect} optionRenderer={this.formatTrasaSelect}/>
                        </Col>
                        <Col xs={1}>
                            <ControlLabel>Godz. odjazdu</ControlLabel>
                            <FormControl type={'time'} onChange={this.onChangeGodzinaOdjazdu}/>
                        </Col>
                        <Col xs={2}>
                            <ControlLabel>Status</ControlLabel>
                            <TopSelect onChange={this.onChangeStatus} value={this.state.status} options={this.state.statusy}/>
                        </Col>
                        <Col xs={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction onClick={this.onClickSzukaj} text={'Szukaj'} btnColor={'primary'} iconType={'fa fa-search'}
                                             btnSize={'md'}/>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazJednorazowych/components/SprzedazSearchbox.js